module.exports = __webpack_public_path__ + "static/pointer-a4649974c08cddd273420bd184c069b8.png";